module.exports = __webpack_public_path__ + "components/flag/static/square/ne-18b55c74c3be8428cf41790233ef5e59.svg";